import { useState } from "react";
import FadeInView from "./FadeInView";
import Typewriter from "./Typewriter";
import Lightbox from "./Lightbox";

const GALLERY_ITEMS = [
  { src: "/img/AyurSutra.png", label: "AyurSutra", ref: "REF.001" },
  { src: "/img/Deviq.png", label: "DevIQ", ref: "REF.002" },
  { src: "/img/chess game.png", label: "Chess Game", ref: "REF.003" },
  { src: "/img/Calculator.png", label: "Calculator", ref: "REF.004" },
  { src: "/img/quoteverse.png", label: "QuoteVerse", ref: "REF.005" },
  { src: "/img/Solaris.png", label: "Solaris To-Do", ref: "REF.006" },
];

export default function Gallery() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const open = (i) => setLightboxIndex(i);
  const close = () => setLightboxIndex(null);

  return (
    <div>
      <FadeInView>
        <p className="section-number"><Typewriter text="[02] ./gallery --visuals" /></p>
        <h2 className="section-title">Gallery</h2>
      </FadeInView>

      <FadeInView delay={0.1}>
        <p className="work-intro">
          {">_ "}A selection of projects and visual work. Click any item to view full-screen.
        </p>
      </FadeInView>

      <div className="gallery-grid">
        {GALLERY_ITEMS.map((item, i) => (
          <FadeInView key={i} delay={i * 0.04}>
            <div className="gallery-item" onClick={() => open(i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && open(i)}>
              <img src={item.src} alt={item.label} loading="lazy" />
              <div className="gallery-item-overlay">
                <span className="gallery-item-ref">{item.ref}</span>
              </div>
            </div>
          </FadeInView>
        ))}
      </div>

      {lightboxIndex !== null && (
        <Lightbox
          items={GALLERY_ITEMS}
          currentIndex={lightboxIndex}
          onClose={close}
          onNavigate={setLightboxIndex}
        />
      )}
    </div>
  );
}
